import { useMutation } from 'react-apollo';
import { defaultDataIdFromObject } from 'apollo-cache-inmemory';

import {
  accountAddressCreate,
  accountAddressUpdate,
} from '../../../../../../graphql/mutations/account';
import { getCheckoutPriceQuery } from '../../../../../../apps/temp/graphql/queries/getCheckoutPrice';
import accountAddresses from '../../../../../../apps/temp/graphql/fragments/account/accountAddresses';

const useCheckoutCartAddress = ({ account, address, checkoutItems }) => {
  const [onCreateAccountAddress] = useMutation(accountAddressCreate);
  const [onUpdateAccountAddress] = useMutation(accountAddressUpdate);

  const createAccountAddress = async (userId, addressData) => {
    const result = await onCreateAccountAddress({
      variables: {
        input: {
          ...addressData,
          account_id: userId,
        },
      },
      update: (store, { data: { accountAddressCreate: response } }) => {
        const addressesFragment = store.readFragment({
          id: defaultDataIdFromObject(account ?? {}),
          fragment: accountAddresses,
        });

        const newAddress = response.account_address;
        addressesFragment.addresses.unshift(newAddress);

        store.writeFragment({
          id: defaultDataIdFromObject(account ?? {}),
          fragment: accountAddresses,
          data: addressesFragment,
        });
      },
    });

    return result;
  };
  const updateAccountAddress = async addressData => {
    const result = await onUpdateAccountAddress({
      variables: {
        input: addressData,
      },
      refetchQueries: [
        {
          query: getCheckoutPriceQuery,
          variables: {
            account_id: account?.id,
            address_id: address?.id,
            ...checkoutItems,
          },
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        },
      ],
    });
    return result;
  };

  return {
    createAccountAddress,
    updateAccountAddress,
  };
};

export default useCheckoutCartAddress;
